import axios from "axios";
import AvatarService from "@services/AvatarService";

const sttApi = axios.create();

let interceptorId = null;

export const setupSttInterceptors = ({onTokenRefreshed} = {}) => {
  if (interceptorId !== null) return;

  interceptorId = sttApi.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error?.config ? {...error.config} : null;

      if (
        error?.response?.status === 401 &&
        originalRequest &&
        !originalRequest._isRetry
      ) {
        originalRequest._isRetry = true;

        const refreshResponse = await AvatarService.getRecordToken();
        const newToken = refreshResponse?.data?.access_token;
        const newHost = refreshResponse?.data?.host;

        if (!newToken || !newHost) {
          return Promise.reject(error);
        }

        originalRequest.baseURL = newHost;
        originalRequest.headers = {
          ...originalRequest.headers,
          Authorization: `Bearer ${newToken}`,
        };

        if (typeof onTokenRefreshed === "function") {
          onTokenRefreshed(refreshResponse.data);
        }

        return sttApi.request(originalRequest);
      }

      return Promise.reject(error);
    },
  );
};

export {sttApi};
